export default "__VITE_ASSET__cbc2e9b6__"